<template>
    <div>
    <hr class="mt-0 mb-2">
    <div class="mb-1 card-body">
        <div class="two-header">
            <div class="d-flex justify-content-between align-items-center has-line">
                <h5 class="card-title mb-0">Ship To</h5>
                <a href="#" class="rtn-edit" data-toggle="modal" data-target="#editShipToModal"><i class="ri-edit-fill me-1"></i> Edit</a>
            </div>
        </div>

        <template v-if="order.is_stocking">
            <template v-if="order.warehouses">
                <template v-for="(item, index) in order.warehouses">
                <div  v-html="formatDescription(item.address)"></div>
                     <!-- <template v-if="item.warehouse">

                        <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                            <template v-if="item.warehouse.address2 !=null">
                                {{ item.warehouse.address2 }}<br>
                            </template>
                            <template v-if="item.warehouse.address !=null">
                                {{ item.warehouse.address }}<br>
                            </template>
                             <template v-if="item.warehouse.city !=null">
                                {{ item.warehouse.city }}
                            </template>   
                            <template v-if="item.warehouse.state !=null">
                                {{ item.warehouse.state }}
                            </template>

                            

                            <template v-if="item.warehouse.post_code !=null">
                                {{ item.warehouse.post_code }}
                            </template>
                        </div>
                    </template>
                    <template v-else>

                        <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                            {{ item.address }}
                        </div>
                    </template> -->

                    
                </template>
            </template>
        </template>
        
    </div>
    <hr class="mt-0 mb-2">
    <div class="mb-1 card-body">
        <div class="two-header">
            <div class="d-flex justify-content-between align-items-center has-line">
                <h5 class="card-title mb-01">Customer Delivery Address</h5>
            </div>
        </div>

        <template  v-for="(item, index) in order.customer_warehouses">
            <div  v-html="formatDescription(item.address)"></div>
            <!-- <template v-if="item.warehouse">

                <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                    <template v-if="item.warehouse.address2 !=null">
                        {{ item.warehouse.address2 }}<br>
                    </template>
                    
                    <template v-if="item.warehouse.address !=null">
                        {{ item.warehouse.address }}<br>
                    </template>

                    <template v-if="item.warehouse.city !=null">
                        {{ item.warehouse.city }}
                    </template>

                    <template v-if="item.warehouse.state !=null">
                        {{ item.warehouse.state }}
                    </template>
                    
                    <template v-if="item.warehouse.post_code !=null">
                        {{ item.warehouse.post_code }}
                    </template>
                    
                    
                    
                    
                </div>
            </template>
            <template v-else>
                <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                    {{ item.address }}
                </div>

                
            </template> -->

            
        </template>
        
    </div>
    <template v-if="!isEditMode && order.is_stocking">
        <hr class="mt-0 mb-2">
        <div class="mb-3 card-body">
            <div class="two-header">
                <div class="d-flex justify-content-between align-items-center has-line">
                    <h5 class="card-title mb-01">Stocking Terms</h5>
                </div>
            </div>
            <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                <div class="text-muted text-center">{{ order.stocking_terms }}</div>
            </div>
        </div>
    </template>
    

    <!-- Edit Ship To Modal -->
                <div class="modal fade" id="editShipToModal" tabindex="-1" aria-labelledby="editShipToModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editShipToModalLabel">Edit Ship To</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                            </div>
                            <div class="modal-body px-0 py-1 form-steps">
                                <div class="hov-sec">
                                    <label>Stocking?</label>
                                    <div class="d-flex">
                                        <div class="form-check me-2">
                                        <input
                                            type="radio"
                                            class="form-check-input radio-ship-yes"
                                            name="is_stocking"
                                            value="1"
                                            v-model="shippingForm.is_stocking"
                                        />

                                            
                                            <label class="form-check-label" for="flex1">
                                                Yes
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                type="radio"
                                                class="form-check-input radio-ship-no"
                                                name="is_stocking"
                                                value="0"
                                                v-model="shippingForm.is_stocking"
                                            />

                                            
                                            <label class="form-check-label" for="flex2">
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="ship-no hov-sec" v-if="shippingForm.is_stocking == 1">
                                    <label>Stocking Terms</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        v-model="shippingForm.stocking_terms"
                                    />
                                    
                                </div>

                                
                        
                                <div class="ship-no hov-sec" v-if="shippingForm.is_stocking == 1">
                                    <div id="sw"></div>
                                    <div class="" v-for="(warehouse, index) in shippingForm.warehouses">
                                        <!-- <template v-if="shippingForm.warehouses[index].address !=  null"> -->
                                            <label>Superb Warehouse</label>
                                            <div class="popup-rown">
                                                <v-select :filter="fuseSearchSuperb" label="address" 
                                                    @input="(value) => warehouseChange(value, 'warehouses', index)"  
                                                    placeholder="Select Superb Warehouse"    
                                                    v-model="shippingForm.warehouses[index].warehouse_id"
                                                    :filterable="true" 
                                                    :options="companyWarehouse" :reduce="(option) => option.id">
                                                    <template slot="no-options">
                                                    Search
                                                    </template>
                                                    <template slot="option" slot-scope="option">

                                                    <div class="d-center" >{{ option.name }}</div>
                                                    
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    
                                                    <div class="selected d-center"> {{ option.name }} </div> 
                                                    
                                                    </template>
                                                </v-select>


                                                
                                                <a
                                                    href="javascript:void(0);"
                                                    @click="
                                                        removeWarehouse(
                                                            warehouse,
                                                            index
                                                        )
                                                    "
                                                    v-if="
                                                        shippingForm.warehouses.length >
                                                        1
                                                    "
                                                    class="btn btn-danger px-3 py-2"
                                                    >Remove</a
                                                >
                                                </div>
                                                
                                                <textarea 
                                                    class="form-control append-edit-address mt-2"
                                                    placeholder=""
                                                    v-model="
                                                        shippingForm.warehouses[index].address
                                                    "
                                                ></textarea>
                                            
                                        <!-- </template> -->
                                        </div>
                                    <div class="mt-2 text-end" v-if="shippingForm.warehouses.length < maxNumOfShipToAddress">
                                        <a
                                            @click="addWarehouse()"
                                            href="javascript:void(0);"
                                            class="btn btn-info add-sw"
                                        >Add</a>
                                        
                                    </div>
                                </div>
                                <div class="hov-sec">
                                    <div id="cw"></div>
                                    <div class=""  v-for="(
                                            warehouse, index
                                        ) in shippingForm.customerWarehouses">
                                        <label>Customer Warehouse</label>
                                        <!-- <v-select v-model="shippingForm.customerWarehouses[index].warehouse_id"
                                        @input="changeRoute($event,index)"
                                         :options="customerWarehouse"
                                         :reduce="(option) => option.warehouse.id" 
                                         :filterable="true" 
                                         label="address" /> -->

                                        <div class="popup-rown">
                                        <v-select :filter="fuseSearch" @search="fetchOptions" 
                                                    @input="(value) => warehouseChange(value, 'customerWarehouses', index)" 
                                                     label="address"   placeholder="Select Customer Warehouse"    
                                                    v-model="shippingForm.customerWarehouses[index].warehouse_id" 
                                                    :filterable="true" 
                                                    :options="customerWarehouse" :reduce="(option) => option.id">
                                                    <template slot="no-options">
                                                    Search
                                                    </template>
                                                    <template slot="option" slot-scope="option">

                                                    <div class="d-center" >{{ option.name }}</div>
                                                    
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    
                                                    <div class="selected d-center"> {{ option.name }} </div> 
                                                    
                                                    </template>
                                                    
                                                </v-select>
                                        

                                        

                                        <a
                                            href="javascript:void(0);"
                                            @click="
                                                removeCustomerWarehouse(
                                                    warehouse,
                                                    index
                                                )
                                            "
                                            v-if="
                                                shippingForm.customerWarehouses
                                                    .length > 1
                                            "
                                            class="btn btn-danger px-3 py-2"
                                            >Remove</a
                                        >
                                        </div>

                                        <textarea 
                                    class="form-control append-edit-address mt-2"
                                    placeholder=""
                                    v-model="
                                        shippingForm.customerWarehouses[index]
                                            .address
                                    "
                                ></textarea>
                                        
                                        
                                    </div>
                                    <div class="mt-2 text-end" v-if="
                                    shippingForm.customerWarehouses.length <
                                    maxNumOfShipToAddress
                                ">
                                 <a
                                    @click="addCustomerWarehouse()"
                                    href="javascript:void(0);"
                                    class="btn btn-info add-cw"
                                    >Add</a
                                >

                                        
                                    </div>
                                </div>
                                <div class="hov-sec">
                                    <div id="bt"></div>
                                    <div class="" v-for="(
                                    warehouse, index
                                ) in shippingForm.billTo">
                                        <label>Bill To</label>
                                        <template v-if="warehouse.warehouse">
                                        <v-select    placeholder="Select Bill To"    
                                                    v-model=" shippingForm.billTo[index].warehouse_id" 
                                                    :filterable="true" 
                                                    :options="shippingForm.billTo" :reduce="(option) => option.warehouse.id">
                                                    <template slot="no-options">
                                                    Search
                                                    </template>
                                                    <template slot="option" slot-scope="option">

                                                    <template v-if="option.warehouse != null">
                                                        <div class="d-center">
                                                            {{ option.warehouse.address }}
                                                        </div>
                                                    </template>
                                                    
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    <template v-if="option.warehouse != null">
                                                        <div class="selected d-center">
                                                            {{ option.warehouse.address }}
                                                        </div>
                                                    </template>
                                                    
                                                    </template>
                                                </v-select>
                                            </template>
                                        <!-- <select
                                            name="cars"
                                            class="custom-select"
                                            v-model="
                                                shippingForm.billTo[index]
                                                    .warehouse_id
                                            "
                                        >
                                            <option
                                                v-for="item in customerWarehouses"
                                                :value="item.id"
                                            >
                                                {{ item.address }}
                                            </option>
                                        </select> -->
                                        <a
                                            href="javascript:void(0);"
                                            @click="
                                                removeBillTo(warehouse, index)
                                            "
                                            v-if="
                                                shippingForm.billTo.length > 1
                                            "
                                            class="btn btn-danger px-3 py-2"
                                            >Remove</a
                                        >
                                        <textarea
                                        class="form-control append-edit-address mt-2"
                                        placeholder=""
                                        v-model="shippingForm.billTo[index].address"
                                    ></textarea>
                                        
                                    </div>
                                    
                                    <div class="mt-2 text-end" v-if="
                                    shippingForm.billTo.length <
                                    maxNumOfShipToAddress
                                ">
                                         <a
                                            @click="addBillTo()"
                                            href="javascript:void(0);"
                                            class="btn btn-info add-bt"
                                            >Add</a
                                        >
                                        <!-- <button class="btn btn-info add-bt">Add</button> -->
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer border-top py-2">
                                <a
                                    href="javascript:void(0);"
                                   
                                    :disabled="loading"
                                    @click="saveShippingData"
                                    class="btn btn-primary w-md"
                                    >Save</a
                                >

                                <!-- <button class="btn btn-primary w-md">Submit</button> -->
                                <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Edit Ship To Modal -->

        
    </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapState } from "vuex";
import Vue from "vue";
import Fuse from 'fuse.js';

export default {
    name: "OrderShipping",
    props: ["order", "loading", "isEditMode","companyWarehouse"],
    mounted() {
        this.syncLatestData();
       this.getCustomerWarehouse();
    },
    data() {
        return {
            shipSearch: null,
            shippingForm: {
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [{
                    id: null,
                    warehouse_id: null,
                    address: null,
                }],
                customerWarehouses: [],
                billTo: [],
            },
            warehouses: [],
            customerWarehouses: [],
            customerWarehouse:[]
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),

         formatDescription(desc) {
        if (!desc) return '';
        return desc.replace(/\n/g, '<br>');
        },

        warehouseChange(event, type, index) {
            //alert("sss"+event);
            if (event == "add_new") {
                this.showWarehouse = true;
                this.warehouseAddType = type;
                this.warehouseAddIndex = index;
                this.shippingForm[type][index].warehouse_id = null;
                //$('#addWarehouseModal').modal('show');
                setTimeout(() => {
                    $("#addWarehouseModal").modal("show");
                }, 100);
            } else {
                let warehouse = null;
                if (
                    type == "billTo" ||
                    type == "customerWarehouses"
                ) {
                    warehouse = this.customerWarehouse.find(
                        (x) => (x.id == event)
                    );
                } else {
                    warehouse = this.companyWarehouse.find(
                        (x) => (x.id == event)
                    );
                }

                console.log("warehouse",warehouse);
                if (warehouse) {
                    //let address = warehouse.address+ '\n';
                     let address = warehouse.name+ '\n';
                     address += warehouse.address+ '\n';
                    if (warehouse.city) {
                        address += ' '+`${warehouse.city}`;
                    }
                     if (warehouse.state) {
                        address += ` ${warehouse.state}`;
                    }
                    if (warehouse.post_code) {
                        address += ' '+`${warehouse.post_code}`;
                    }

                    // if (warehouse.city) {
                    //     address += `${warehouse.city}`+ '\n';
                    // }
                    // if (warehouse.state) {
                    //     address += `${warehouse.state}`+ '\n';
                    // }
                    // if (warehouse.post_code) {
                    //     address += `${warehouse.post_code}`;
                    // }

                    this.shippingForm[type][index].address = address;
                }
            }
        },

        changeSuperbData(value,index){
            console.log("this.shippingForm.warehouses",this.shippingForm.warehouses)
            // let carriers = this.companyWarehouse.filter(
            //              (x) => x.id == value
            //          );

            // if(carriers.length > 0){
            //     // let idChange = x.id + Math.floor(Math.random() * 100)
            //     // xData = Object.assign(xData, {warehouse: {id:idChange,address:x.address,custom:1}});
            //     if(this.shippingForm.warehouses[index].select_warehouse){
            //         console.log("select_warehouse exists");
            //         this.shippingForm.warehouses[index].select_warehouse = carriers[0];
            //     }
            //     else{
            //         this.shippingForm.warehouses[index].select_warehouse = carriers[0];
            //         console.log("select_warehouse not exists");
            //     }
            //     this.shippingForm.warehouses[index].address = carriers[0].address
            // }
            
            
            
            // console.log("dddddddd",value);
            // console.log("dddddddd index",index);
        },

        
        fuseSearchSuperb(options, search) {
            const fuse = new Fuse(options, {
                keys: ['address2', 'address', 'state','city'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },
        
        fuseSearch(options, search) {
            const fuse = new Fuse(options, {
                keys: ['address2', 'warehouse.address', 'warehouse.state','warehouse.city','state','city'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },

        fetchOptions(search, loading){
            console.log("serach",search);
        },
        changeRoute(value,index){
            //this.shippingForm.customerWarehouses[index].warehouse_id = value;
            console.log("this.shippingForm.customerWarehouses",this.shippingForm.customerWarehouses)
            // let carriers = this.customerWarehouse.filter(
            //              (x) => x.warehouse.id == value
            //          );

            // if(carriers.length > 0){
            //     // let idChange = x.id + Math.floor(Math.random() * 100)
            //     // xData = Object.assign(xData, {warehouse: {id:idChange,address:x.address,custom:1}});
            //     if(this.shippingForm.customerWarehouses[index].select_warehouse){
            //         console.log("select_warehouse exists");
            //         this.shippingForm.customerWarehouses[index].select_warehouse = carriers[0];
            //     }
            //     else{
            //         this.shippingForm.customerWarehouses[index].select_warehouse = carriers[0];
            //         console.log("select_warehouse not exists");
            //     }
            //     this.shippingForm.customerWarehouses[index].address = carriers[0].address
            // }
            
            
            
            // console.log("dddddddd",value);
            // console.log("dddddddd index",index);
        },
        addWarehouse() {
            this.shippingForm.warehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
                warehouse:{
                    id:null
                }
            });
        },
        removeWarehouse(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "superb");
            } else {
                this.shippingForm.warehouses.splice(index, 1);
            }
        },
        addCustomerWarehouse() {
            this.shippingForm.customerWarehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
                warehouse:{
                    id:null
                }
            });
        },
        removeCustomerWarehouse(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "customer");
            } else {
                this.shippingForm.customerWarehouses.splice(index, 1);
            }
        },
        addBillTo() {
            this.shippingForm.billTo.push({
                id: null,
                warehouse_id: null,
                address: null,
                warehouse:{
                    id:null
                }
            });
        },
        removeBillTo(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "customer", true);
            } else {
                this.shippingForm.billTo.splice(index, 1);
            }
        },
        getCustomerWarehouse() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("getWarehouses.customer", {customer_id:this.order.customer_id}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerWarehouse = data.data;
                        console.log("customerWarehouse",data.data)
                        // data.data.forEach((x) => {

                            
                        //      let xData = x;
                             
                        //       //var albums = ["off the wall","thriller","beat it"];
                        //       let idChange = x.id + Math.floor(Math.random() * 100)
                        //      xData = Object.assign(xData, {warehouse: {id:idChange,address:x.address,custom:1}});
                        //     // console.log("xData",xData);
                        //     // xData.warehouse.id = null;
                        //     // console.log("xData",xData);
                        //      this.customerWarehouse.push(xData)
                        // });

                        // this.order.customer_warehouses.forEach((x) => {
                        //     this.customerWarehouse.push(x)
                        // });
                        // console.log("this.customerWarehouses final data",this.customerWarehouse);

                        //  console.log("customer warehouse ",data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

        getWarehouses(is_customer = 1) {

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            let url = window.route("getWarehouses");
            if (is_customer) {
                if (this.order.customer) {
                    url = window.route("getWarehouses", {
                        customer_id: this.order.customer.id,
                    });
                } else {
                    return;
                }
            }
            return axios
                .get(url, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        if (is_customer) {
                            this.customerWarehouses = data.data;
                            let defaultWarehouses =
                                this.customerWarehouses.filter(
                                    (x) => x.is_default
                                );
                            if (
                                defaultWarehouses.length &&
                                (this.shippingForm.customerWarehouses[0]
                                    .address == null ||
                                    this.shippingForm.customerWarehouses[0]
                                        .address == "") &&
                                this.shippingForm.customerWarehouses[0]
                                    .warehouse_id == null
                            ) {
                                this.shippingForm.customerWarehouses[0].warehouse_id =
                                    defaultWarehouses[0].id;
                            }
                        } else {
                            this.warehouses = data.data;
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        saveShippingData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("so.updateOrderShippingData", {
                        id: this.order.id,
                    }),
                    this.shippingForm,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.$emit("updatedShippingEvent");
                        self.$emit("updatedShippingNewEvent");
                        $('#editShipToModal').modal('hide');
                        //self.isEditMode = false;
                        /*self.customerForm = {
                            customer: null,
                            customer_id: null,
                        };*/
                        self.setSuccessMessage("Order saved successfully");
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        deleteWarehouse(id, type = "customer", isBill = false) {
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("orders.warehouses.destroy", {
                                    id: self.order.id,
                                    warehouse_id: id,
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.$emit("updatedShippingEvent");
                                    self.$emit("updatedShippingNewEvent");
                                    self.setSuccessMessage(
                                        "Warehouse deleted from order!"
                                    );
                                    if (type === "customer") {
                                        if (isBill) {
                                            self.order.products.splice(
                                                self.shippingForm.billTo.indexOf(
                                                    (x) => x.id == id
                                                ),
                                                1
                                            );
                                        } else {
                                            self.order.products.splice(
                                                self.shippingForm.customerWarehouses.indexOf(
                                                    (x) => x.id == id
                                                ),
                                                1
                                            );
                                        }
                                    } else {
                                        self.order.products.splice(
                                            self.shippingForm.warehouses.indexOf(
                                                (x) => x.id == id
                                            ),
                                            1
                                        );
                                    }
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },
        syncLatestData() {

            
            //console.log("snyc from this.customer_warehouses ",this.order.customer_warehouses)
            this.shippingForm.is_stocking = this.order.is_stocking;
            this.shippingForm.stocking_terms = this.order.stocking_terms;
            if(this.order.warehouses.length > 0){
                this.shippingForm.warehouses = _.cloneDeep(this.order.warehouses);
            }
            
            this.shippingForm.customerWarehouses = _.cloneDeep(
                this.order.customer_warehouses
            );
            
            // this.customerWarehouses = _.cloneDeep(
            //     this.order.customer_warehouses
            // );
            
             
             
            this.shippingForm.billTo = _.cloneDeep(this.order.bill_warehouses);

            // if (
            //     this.order.warehouses &&
            //     this.order.warehouses.length == 0
            // ) {
            //     this.shippingForm.warehouses = [
            //                 {
            //                     id: null,
            //                     warehouse_id: null,
            //                     address: null,
            //                     warehouse:{
            //                         id:null
            //                     }

            //                 },
            //             ];

            // }
            

            if (
                this.order.customer_warehouses &&
                this.order.customer_warehouses.length == 0
            ) {
                this.shippingForm.customerWarehouses = [
                    {
                        id: null,
                        warehouse_id: null,
                        address: null,
                        warehouse:{
                                    id:null
                                }
                    },
                ];
            }

            if (
                this.order.bill_warehouses &&
                this.order.bill_warehouses.length == 0
            ) {
                this.shippingForm.billTo = [
                    {
                        id: null,
                        warehouse_id: null,
                        address: null,
                        warehouse:{
                                    id:null
                                }
                    },
                ];
            }
        },
    },
    computed: {
        ...mapState(["salesOrderState"]),
        ...mapGetters(["maxNumOfShipToAddress"]),
    },
    watch: {
        "shippingForm.is_stocking": {
            handler: function (after, before) {
                if (after == 1) {

                                      

                    if (this.warehouses.length) {
                        let defaultWarehouses = this.warehouses.filter(
                            (x) => x.is_default
                        );
                        if (defaultWarehouses.length) {
                            this.shippingForm.warehouses[0].warehouse_id =
                                defaultWarehouses[0].id;
                        }
                    }
                } else {
                    console.log("ddddddddddddddddddddddddd");
                    //this.shippingForm.warehouses = [];
                }
            },
        },
        order: {
            handler: function (after, before) {
                this.syncLatestData();
            },
        },
        companyWarehouse: {
            handler: function (after, before) {
                console.log("snyc from order shipping companyWarehouse ",this.companyWarehouse)
            },
        },
        
        "shippingForm.customerWarehouses":{
            handler: function (after, before) {
                console.log("after",after);
            },
        },
        
    },
};
</script>

<style scoped></style>
